module.exports = __webpack_public_path__ + "7595ab88aeb14c7ec0ae271fc31f35b0.svg";